import React from 'react';

function GiftIcon({ width = 24, height = 24, ...rest }) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24" strokeWidth="1" fill="none"
      stroke="currentColor">
      <g>
        <path strokeLinecap="round" strokeLinejoin="round"
          d="M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 004.875-4.875V12m6.375 5.25a4.875 4.875 0 01-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 013.182 3.182zM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 113.182-3.182z" />
      </g>
    </svg>
  );
}

export default GiftIcon;
